import { Component, Input} from '@angular/core';
import { UserService} from '../../shared/services/user_service';
import { ActivatedRoute} from '@angular/router';
import { Note } from '../../shared/types/note';

@Component({
  selector: 'featured-notes',
  templateUrl: './featured-notes.component.html',
  styleUrls: ['./featured-notes.component.scss']
})
export class FeaturedNotesComponent {
  @Input() notes: Note[];
  @Input() offset: [number, number];
  @Input() showSearch: boolean;
  @Input() showSearchBarOnMobile: boolean;
  @Input() showPlaceholders: boolean;

  public searchFormProps: object = {
    customClass: 'search-holder',
    showIcon: true,
    iconSide: 'left',
    showButton: false,
    inputPlaceholder: 'Search our notes',
    buttonText: 'Want to write your own streams?'
  };

  constructor(
    private userService: UserService,
    private route: ActivatedRoute) {
    }
}
